import React from 'react';
import { TableDataCase } from '../TableDataCase';
import {
  formatDate,
  todayIsBetween
} from '../../../../../helpers/date/formatDate';
import { ElevesDashboardProf } from '../../../../../types/classe/maClasse';
import { QuizTabDef } from '../../../../../types/quiz/quiz.def';
import useStyle from './tableDataLineQuizProf.style';
import useGoToPage from '../../../../../hooks/useGoToPage';
import pages from '../../../../../routes/pages';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../store/reducers';

interface TableDataLineQuizProps {
  quiz: QuizTabDef;
  eleves: ElevesDashboardProf[];
}

export const SuiviQuiz = ({
  quizId,
  users
}: {
  quizId: string;
  users: ElevesDashboardProf[];
}) => {
  const classes = useStyle();

  const remainingStudents = users.filter(
    user => !user?.quiztonote?.find(q => q.quiz && q.quiz.id === quizId)
  ).length;
  return (
    <div className={classes.suiviQuizContainer}>
      {remainingStudents > 0 ? (
        <p className={classes.red}>
          {remainingStudents} personne
          {remainingStudents > 1 ? "s n'ont " : " n'a "}pas répondu à ce quiz
        </p>
      ) : (
        <p className={classes.green}>Tous les éléves ont répondu</p>
      )}
    </div>
  );
};

export const TableDataLineQuizProf = ({
  quiz,
  eleves
}: TableDataLineQuizProps) => {
  const status = todayIsBetween(quiz.debut, quiz.fin) ? 'En cours' : 'Terminé';
  const classeId = useSelector((state: AppState) => state?.user?.classe.id);
  const goToRecapQuiz = useGoToPage(pages.RECAP_QUIZ_CLASSE_PAGE.path, {
    id: quiz.id,
    classeId: classeId
  });
  return (
    <>
      <tr>
        <TableDataCase variant={'data'} data={quiz.name} />
        <TableDataCase
          variant={'data'}
          data={`Du ${formatDate(new Date(quiz.debut))} au ${formatDate(
            new Date(quiz.fin)
          )}`}
        />
        <TableDataCase
          variant={'data'}
          data={status}
          color={todayIsBetween(quiz.debut, quiz.fin) ? 'green' : 'normal'}
        />
        <TableDataCase
          variant={'data'}
          data={<SuiviQuiz quizId={quiz.id} users={eleves} />}
        />
        <TableDataCase onClick={goToRecapQuiz} variant={'icon'} icon={'Form'} />
      </tr>
    </>
  );
};
